import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllAgents } from "../../api/apiAgents";
import parseError from "../../utils/parseError";

const useDeleteAllAgents = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAllAgentsAction, isPending } = useMutation({
        mutationFn: deleteAllAgents,
        onSuccess: (res) => {
            const message = res?.message || "Agents archived successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["agents"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to archive agents");
        },
    });

    return { deleteAllAgents: deleteAllAgentsAction, isPending };
};

export default useDeleteAllAgents;
